import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";
import styled from "styled-components";
import i18n from "../i18n";
import Axios from "axios";

import { Button } from "ia-react-ui-components";

import Header from "./Header";
import GenerateInputArea from "./GenerateInputArea";
import GenerateSummary from "./GenerateSummary";
import ModalCancel from "./ModalCancel";

const LinkCancel = styled.a`
  body && {
    font-size: 16px;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 600;
  }
`;

let interviewSummary = {
  name: "",
  lang: "",
  sections: []
};

export class SectionSummary extends Component {
  constructor(props) {
    super(props);

    let sessionInterview = JSON.parse(sessionStorage.getItem("interview"));

    if (sessionInterview) {
      this.props.interview.sections = sessionInterview.sections;
    }

    this.props.interview.lang = i18n.language.includes("en") ? "en" : "fr";

    this.state = {
      questions: this.props.interview.sections[this.props.step].questions,
      interview: this.props.interview,
      disableSubmit: true,
      isModalVisible: false
    };
  }

  ////////////////////
  //Common Functions//
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  openModal = () => {
    this.setState({ isModalVisible: true });
  };

  closeModal = () => {
    this.setState({ isModalVisible: false });
  };
  //End Common Functions//
  ////////////////////////

  //Not saving when going to previous page as we want the user to
  //always tick off the declaration if they move off the page
  goToPage = direction => {
    if (direction === "previous") {
      this.props.history.push("/SectionSix");
    } else {
      this.createSummary();
      this.submit();
    }
  };

  createSummary = () => {
    interviewSummary.name =
      this.props.interview.lang === "en"
        ? this.props.interview.name_e
        : this.props.interview.name_f;
    interviewSummary.lang = this.props.interview.lang;

    for (let i = 0; i < this.props.interview.sections.length; i++) {
      //for (let i = 1; i < 2; i++) {
      let currSection = this.props.interview.sections[i];
      let hideSection = currSection.hideSection;
      let section = {
        id: "",
        name: "",
        questions: []
      };
      section.id = currSection.section_id;
      section.name =
        this.props.interview.lang === "en"
          ? currSection.name_e
          : currSection.name_f;

      for (let j = 0; j < currSection.questions.length; j++) {
        let hideQuestion = false;
        let currQuestion = currSection.questions[j];

        let question = {
          n: "",
          q: "",
          v: ""
        };

        if (currQuestion.group !== undefined) {
          for (let a = 0; a < currSection.groups.length; a++) {
            for (let b = 0; b < currQuestion.group.length; b++) {
              if (currQuestion.group[b] === currSection.groups[a].name) {
                /*   console.log("section group name: " + currSection.groups[a].name)
                console.log("section group hide value: " + currSection.groups[a].hide)
                console.log("question group: " + currQuestion.group[b]) */
                if (currSection.groups[a].hide === true) {
                  hideQuestion = true;
                } else {
                  hideQuestion = false;
                }
              }
            }
          }
        }

        if (hideQuestion === false) {
          //  console.log(currQuestion);
          switch (currQuestion.question_type) {
            //use the key to get the option with correct language
            //in case client switches language before submission
            //note that the key is saved as the 'value' in the fnol questions
            case "radioHide":
              if (!!currQuestion.value) {
                question = {
                  n: currQuestion.name,
                  q:
                    this.props.interview.lang === "en"
                      ? currQuestion.question_e
                      : currQuestion.question_f,
                  v:
                    this.props.interview.lang === "en"
                      ? currQuestion.options_e.filter(
                          option => option.key === currQuestion.value
                        )[0].value
                      : currQuestion.options_f.filter(
                          option => option.key === currQuestion.value
                        )[0].value
                };
              } else {
                question = {
                  n: currQuestion.name,
                  q:
                    this.props.interview.lang === "en"
                      ? currQuestion.question_e
                      : currQuestion.question_f,
                  v: ""
                };
              }
              break;
            //key is saved as value in fnol ddl question
            //in dropdown, the options value is saved as translation
            case "dropdown":
              // console.log(currQuestion);
              if (!!currQuestion.value) {
                question = {
                  n: currQuestion.name,
                  q:
                    this.props.interview.lang === "en"
                      ? currQuestion.question_e
                      : currQuestion.question_f,
                  v:
                    this.props.interview.lang === "en"
                      ? currQuestion.options_e.filter(
                          option => option.key === currQuestion.value
                        )[0].translation
                      : currQuestion.options_f.filter(
                          option => option.key === currQuestion.value
                        )[0].translation
                };
              } else {
                question = {
                  n: currQuestion.name,
                  q:
                    this.props.interview.lang === "en"
                      ? currQuestion.question_e
                      : currQuestion.question_f,
                  v: ""
                };
              }
              break;
            //arrays are passed for both as question and answer
            //have multiple options to be handled on wrapper side
            case "checkboxHide":
            case "checkbox":
              let responseArray = [];
              let response = {};

              for (let i = 0; i < currQuestion.options_e.length; i++) {
                response = {
                  key:
                    this.props.interview.lang === "en"
                      ? currQuestion.options_e[i]
                      : currQuestion.options_f[i],
                  value:
                    currQuestion.value[i] === true
                      ? this.props.interview.lang === "en"
                        ? "Yes"
                        : "Oui"
                      : this.props.interview.lang === "en"
                      ? "No"
                      : "Non"
                };
                responseArray = [...responseArray, response];
              }

              question = {
                n: currQuestion.name,
                q:
                  this.props.interview.lang === "en"
                    ? currQuestion.question_e
                    : currQuestion.question_f,
                v: "",
                options: responseArray
              };
              break;
            default:
              question = {
                n: currQuestion.name,
                q:
                  this.props.interview.lang === "en"
                    ? currQuestion.question_e
                    : currQuestion.question_f,
                v: currQuestion.value
              };
          }

          section.questions = [...section.questions, question];
        }
      }

      if (!hideSection) {
        interviewSummary.sections = [...interviewSummary.sections, section];
      }
    }
  };

  clearSummary = () => {
    interviewSummary = {
      name: "",
      lang: "",
      sections: []
    };
  };

  disableSubmitHandler = (value, name) => {
    let disableSubmit = "";

    //disable attribute recognizes either "" or "disabled" not true/false
    switch (name) {
      case "q1":
        if (value === true) {
          disableSubmit = false;
        } else {
          disableSubmit = true;
        }
        break;
      default:
        break;
    }

    this.setState({ disableSubmit: disableSubmit });
  };

  submit = () => {
    const { t } = this.props;

    let id =
      (window.location.hostname === "localhost"
        ? "http://localhost:27269/"
        : "/CMMWPNP2/") + "Home/SubmitInterview";
    this.setState(
      { interview: this.props.interview, disableSubmit: true },
      () => {
        Axios.post(id, interviewSummary)
          .then(response => {
            // Success
            if (response.data === "True") {
              this.props.clearInterview();
              this.clearSummary();
              this.props.history.push("/SectionConfirmation");
            } else {
              alert(t("common.errorSubmit"));
            }
          })
          .catch(error => {
            // Error

            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log("Other error");
            }
          });
      }
    );
  };

  render() {
    const { t } = this.props;
    var questions = this.props.interview.sections[this.props.step].questions;
    var lang = this.props.interview.lang;

    var layout = [[["q1"]]];

    return (
      <React.Fragment>
        <ModalCancel
          isVisible={this.state.isModalVisible}
          closeModal={this.closeModal}
          history={this.props.history}
          clearInterview={this.props.clearInterview}
        />

        <Header step={this.props.step + 1} lang={lang} />

        <h1>{t("section_summary.header1")}</h1>

        <div className="injectIaStyles">
          <GenerateSummary interview={this.props.interview} />
          <GenerateInputArea
            layout={layout[0]}
            lang={lang}
            questions={questions}
            hideHandler={this.disableSubmitHandler}
          />
          <Row>
            <Col sm="2">
              <Button id="btnPrev" onClick={() => this.goToPage("previous")}>
                {t("common.previous")}
              </Button>
            </Col>
            <Col sm="2">
              <Button
                id="btnSubmit"
                disabled={this.state.disableSubmit}
                onClick={() => this.goToPage("next")}
              >
                {t("common.submit")}
              </Button>
            </Col>
            <Col sm="8">
              <div style={{ verticalAlign: "middle", lineHeight: "45px" }}>
                <LinkCancel onClick={this.openModal}>
                  {t("common.cancel")}
                </LinkCancel>
              </div>
            </Col>
          </Row>
        </div>
        <br />
      </React.Fragment>
    );
  }
}

export default translate("translate")(SectionSummary);
